// Arabisch (ar), kamers: zelfde vorm als kamers.nl.ts. Kamers, schoonmaakkast, kindslot en
// voorlezen. Meervoud met alle Arabische vormen (zero/one/two/few/many/other).
export const kamersAr = {
    nav: {
        rooms: 'الغرف',
        cleaning: 'التنظيف',
        kidLock: 'قفل الأطفال',
    },
    roomKind: {
        living: 'غرفة الجلوس',
        bedroom: 'غرفة النوم',
        utility: 'غرفة الغسيل أو الخزانة',
    },
    rooms: {
        title: 'الغرف',
        intro: 'كل جهاز لوحي ينتمي إلى غرفة. الغرفة تحدد من يظهر على الجهاز.',
        add: 'غرفة',
        addTitle: 'غرفة جديدة',
        everyone: 'الجميع',
        tablets: {
            zero: 'لا أجهزة لوحية',
            one: 'جهاز لوحي واحد',
            two: 'جهازان لوحيان',
            few: '{count} أجهزة لوحية',
            many: '{count} جهازًا لوحيًا',
            other: '{count} جهاز لوحي',
        },
        noTablet: 'لا جهاز لوحي بعد',
        modeAgenda: 'الأجندة والمهام',
        modeLogboek: 'خزانة التنظيف',
        open: 'فتح',
        back: 'الغرف',
        name: 'الاسم',
        nameHint: 'مثلًا: غرفة سامي ودانة',
        kind: 'نوع الغرفة',
        whoTitle: 'من يظهر على هذا الجهاز؟',
        whoIntro: 'على جهاز غرفة النوم يظهر فقط من ينام فيها.',
        whoAll: 'الجميع',
        whoExplicit: 'سكان الغرفة فقط',
        residents: 'سكان الغرفة',
        residentsHint: 'اضغط على وجه لتشغيله أو إيقافه.',
        noResidentsWarning: 'اختر من ينام هنا، وإلا يبقى الجهاز فارغًا.',
        noResidentsUtility: 'بدون سكان يمكن لكل واحد أن يختار نفسه على هذا الجهاز.',
        householdWide: 'اعرض أيضًا مواعيد العائلة كلها',
        showTitle: 'ماذا يعرض الجهاز؟',
        showAgenda: 'الأجندة والمهام',
        showAgendaHint: 'اللوحة العادية مع اليوم والأسبوع والمهام.',
        showLogboek: 'خزانة التنظيف',
        showLogboekHint: 'مربعات كبيرة: من غسل الملابس، ومن كنس.',
        a11yTitle: 'سهولة الاستخدام على الجهاز',
        readAloud: 'القراءة بصوت عالٍ',
        readAloudHint: 'اضغط على صورة فيقرؤها الجهاز. مفيد لمن لا يقرأ بعد.',
        textSize: 'حجم النص',
        textNormal: 'عادي',
        textLarge: 'كبير',
        textFar: 'كبير جدًا',
        calmMotion: 'حركة هادئة',
        calmMotionHint: 'بلا احتفالات متحركة، كل شيء يظهر بهدوء.',
        sounds: 'الصوت',
        tabletsTitle: 'الأجهزة في هذه الغرفة',
        tabletsEmpty: 'لا يوجد جهاز لوحي هنا بعد.',
        moveHere: 'انقل جهازًا إلى هنا',
        moveChoose: 'اختر جهازًا',
        moved: '{name} الآن في {room}.',
        lastSeen: 'آخر ظهور {ago}',
        save: 'حفظ',
        saved: 'تم الحفظ. يعرضه الجهاز خلال دقيقة.',
        created: 'أُضيفت {name}.',
        remove: 'حذف الغرفة',
        removeBlocked: 'انقل الجهاز أولًا إلى غرفة أخرى.',
        removeTitle: 'حذف الغرفة؟',
        removeBody: 'ستختفي {name}. يبقى السجل محفوظًا.',
        removeConfirm: 'حذف',
        removed: 'حُذفت {name}.',
        lastRoom: 'يجب أن تبقى في البيت غرفة واحدة على الأقل.',
        conflict: 'غيّر شخص آخر هذه الغرفة في هذه الأثناء. حمّلنا أحدث نسخة.',
        emptyTitle: 'لكل غرفة لوحتها',
        emptyBody: 'علّق جهازًا لوحيًا في غرفة النوم أو غرفة الغسيل واختر من يظهر هناك.',
        notFound: 'هذه الغرفة غير موجودة (بعد الآن).',
    },
    cleaning: {
        title: 'التنظيف',
        add: 'مهمة',
        tabTurn: 'الدور على',
        tabHistory: 'السجل',
        tabItems: 'المهام',
        turnIntro: 'الدور على من لم يقم بالمهمة منذ أطول وقت.',
        status: { fresh: 'تمت للتو', soon: 'قريبًا', due: 'حان وقتها' },
        every: {
            zero: 'كل يوم',
            one: 'كل يوم',
            two: 'كل يومين',
            few: 'كل {count} أيام',
            many: 'كل {count} يومًا',
            other: 'كل {count} يوم',
        },
        everyWeek: 'كل أسبوع',
        every2Weeks: 'كل أسبوعين',
        everyMonth: 'كل شهر',
        lastBy: 'آخر مرة: {name}، {when}',
        never: 'لم تُنجز أبدًا',
        turn: 'الدور على',
        doneAction: 'تمت…',
        doneTitle: 'تمت {item}',
        who: 'من',
        when: 'متى',
        time: 'الوقت',
        whenHint: 'يمكنك الرجوع حتى 30 يومًا.',
        note: 'ملاحظة',
        logged: '{item}: قام بها {name}.',
        loggedNoPoints: 'تم الحفظ. بلا نقاط: قام بها {name} من قبل في {when}.',
        points: {
            zero: '{count} نجمة',
            one: 'نجمة واحدة',
            two: 'نجمتان',
            few: '{count} نجوم',
            many: '{count} نجمة',
            other: '{count} نجمة',
        },
        alreadyBy: 'قام بها {name} من قبل',
        deleted: 'محذوفة',
        source: { kiosk: 'على الجهاز اللوحي', app: 'في التطبيق' },
        removeLog: 'حذف',
        removeLogTitle: 'حذف هذه المرة؟',
        removeLogBody: 'لن يحصل {name} على النقاط بعد الآن.',
        removeLogConfirm: 'حذف',
        logRemoved: 'تم الحذف.',
        negativeTitle: 'سيصبح الرصيد سالبًا',
        negativeBody: 'صرف {name} النقاط من قبل. هل تحذف رغم ذلك؟',
        historyEmptyTitle: 'لم يُنجز شيء بعد',
        historyEmptyBody: 'عندما يسجل أحد شيئًا، ستراه هنا.',
        filterAll: 'الجميع',
        filterLabel: 'تصفية حسب الفرد',
        showDeleted: 'اعرض المحذوف أيضًا',
        today: 'اليوم',
        yesterday: 'أمس',
        itemsIntro: 'المهام لكل مكان وكم مرة تتكرر.',
        noLocation: 'بلا مكان',
        edit: 'تعديل',
        archive: 'إزالة',
        archived: 'أُزيلت {name}.',
        editorNew: 'مهمة جديدة',
        editorEdit: 'تعديل المهمة',
        itemName: 'الاسم',
        itemNameHint: 'قصير وواضح، مثلًا: تشغيل الغسالة',
        icon: 'الرمز',
        location: 'المكان',
        newLocation: 'مكان جديد…',
        newLocationName: 'اسم المكان',
        howOften: 'كم مرة',
        customDays: 'عدد الأيام',
        pointsLabel: 'النقاط',
        pointsHint: 'مرة واحدة على الأكثر في كل فترة، حتى لو قام بها عدة أشخاص.',
        participants: 'من يشارك',
        participantsHint: 'إن لم تختر أحدًا = الجميع.',
        saved: 'تم الحفظ.',
        conflict: 'تغيّرت هذه المهمة في هذه الأثناء. حمّلنا أحدث نسخة.',
        emptyTitle: 'لا مهام تنظيف بعد',
        emptyBody: 'ابدأ بشيء يتكرر كثيرًا، مثل الغسالة.',
        emptyAction: 'إضافة مهمة',
        suggestions: 'أو ابدأ بمثال',
        suggest: {
            laundry: 'تشغيل الغسالة',
            hang: 'نشر الغسيل',
            bath: 'تنظيف الحمام',
            vacuum: 'الكنس بالمكنسة',
            plants: 'سقي النباتات',
        },
        loadError: 'حدث خطأ ما. حاول مرة أخرى.',
        retry: 'حاول مرة أخرى',
    },
    kidLock: {
        title: 'قفل الأطفال',
        intro: 'مفيد إذا كان الإخوة يشطبون مهام بعضهم. مطفأ في الأصل؛ القفل يعمل على الجهاز اللوحي فقط.',
        none: 'بلا قفل',
        pin: 'رمز رقمي',
        picture: 'رمز بالصور',
        since: 'منذ {when}',
        waiting: 'انتظار حتى {time}',
        set: 'ضبط',
        change: 'تغيير',
        sheetTitle: 'قفل الأطفال لـ {name}',
        kindLabel: 'نوع القفل',
        noneHint: 'يمكن لأي أحد الضغط باسم {name} على الجهاز.',
        pinHint: '4 أرقام يتذكرها {name}.',
        pictureHint: '4 صور بالترتيب. دع {name} يختارها بنفسه.',
        pinLabel: 'الرمز الرقمي (4 أرقام)',
        pinRepeat: 'مرة أخرى',
        pinMismatch: 'الرمزان غير متطابقين.',
        pinInvalid: 'اختر 4 أرقام بالضبط.',
        pictureChosen: 'تم اختيار {count} من 4',
        pictureClear: 'مسح',
        pictureInvalid: 'اختر 4 صور.',
        pictureSlot: 'الصورة {n}',
        saved: 'تم تعديل قفل {name}.',
        removed: 'قفل {name} مطفأ الآن.',
        emptyTitle: 'لا أطفال بعد',
        emptyBody: 'أضف أطفالك أولًا في أفراد العائلة.',
        about: 'نسي الرمز؟ اضبط رمزًا جديدًا هنا. بعد خمس محاولات خاطئة على الجهاز يجب الانتظار قليلًا.',
    },
    picture: {
        fox: 'ثعلب',
        cat: 'قطة',
        rabbit: 'أرنب',
        bear: 'دب',
        panda: 'باندا',
        owl: 'بومة',
        lion: 'أسد',
        frog: 'ضفدع',
        turtle: 'سلحفاة',
    },
    voice: {
        dictate: 'تحدّث',
        listening: 'أنا أستمع…',
        stop: 'إيقاف',
        heard: 'سمعت: {text}',
        failed: 'لم أفهم ذلك. اكتبه من فضلك.',
    },
    kiosk: {
        entry: 'التنظيف',
        title: 'خزانة التنظيف',
        back: 'رجوع',
        who: 'من قام بها؟',
        hold: 'اضغط على وجهك حتى تمتلئ الدائرة',
        holdShort: 'اضغط باستمرار',
        status: { fresh: 'تمت للتو', soon: 'قريبًا', due: 'حان وقتها' },
        never: 'أبدًا',
        justNow: 'الآن',
        minutesAgo: {
            zero: '{count} دقيقة',
            one: 'دقيقة',
            two: 'دقيقتان',
            few: '{count} دقائق',
            many: '{count} دقيقة',
            other: '{count} دقيقة',
        },
        hoursAgo: {
            zero: '{count} ساعة',
            one: 'ساعة',
            two: 'ساعتان',
            few: '{count} ساعات',
            many: '{count} ساعة',
            other: '{count} ساعة',
        },
        daysAgo: {
            zero: '{count} يوم',
            one: 'يوم',
            two: 'يومان',
            few: '{count} أيام',
            many: '{count} يومًا',
            other: '{count} يوم',
        },
        goodJob: 'أحسنت يا {name}!',
        /** Rustig, buiten het thema Kinderen (geen lof, geen sterren). */
        goodJobCalm: 'أنجزها {name}',
        stars: {
            zero: '+{count} نجمة',
            one: '+{count} نجمة',
            two: '+{count} نجمتان',
            few: '+{count} نجوم',
            many: '+{count} نجمة',
            other: '+{count} نجمة',
        },
        alreadyDone: 'قام بها {name} الساعة {time}. شكرًا على كل حال!',
        alreadyDoneCalm: 'قام بها {name} الساعة {time}.',
        oops: 'تراجع',
        undone: 'أُزيلت',
        other: 'شيء آخر…',
        otherTitle: 'ماذا فعلت؟',
        sayIt: 'قلها',
        emptyTitle: 'لا مهام بعد',
        emptyBody: 'بابا أو ماما يجهزها في التطبيق.',
        notSaved: 'لم تُحفظ بعد، سنحاول بعد قليل.',
        close: 'إغلاق',
        lockAskPin: '{name}، ما رمزك؟',
        lockAskPicture: '{name}، أي صور؟',
        lockWrong: 'مرة أخرى',
        lockWait: 'انتظر قليلًا…',
        lockDigit: 'الرقم {digit}',
        lockErase: 'مسح',
        lockProgress: '{count} من 4',
        adhoc: {
            windows: 'تنظيف النوافذ',
            sweep: 'الكنس',
            trash: 'إخراج القمامة',
            dishes: 'غسل الصحون',
            'tidy-up': 'الترتيب',
            'water-plants': 'سقي النباتات',
            recycling: 'الزجاج والورق',
            'make-bed': 'تغيير الشراشف',
        },
    },
    speech: {
        at: 'الساعة {time}',
        points: {
            zero: '{count} نجمة',
            one: 'نجمة واحدة',
            two: 'نجمتان',
            few: '{count} نجوم',
            many: '{count} نجمة',
            other: '{count} نجمة',
        },
    },
    a11y: {
        skipToContent: 'إلى المحتوى',
        mainNav: 'القائمة الرئيسية',
    },
};
//# sourceMappingURL=kamers.ar.js.map